import { FETCH_USER_SUCCESS } from '../actions/user'

import { USER_LOGIN_FAILURE, USER_LOGGED_OUT } from '../actions/auth'

export default (state = {}, action) => {
    switch (action.type) {
        case FETCH_USER_SUCCESS:
            return { ...action.payload, role:"" }
        case USER_LOGGED_OUT:
        case USER_LOGIN_FAILURE:
            return {}
        default:
            return state
    }
}